import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "@/i18n/LangContext";
import { ContentProvider } from "@/cms/ContentContext";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { useDynamicFavicon } from "@/hooks/useDynamicFavicon";
import Home from "@/pages/Home";
import Terms from "@/pages/Terms";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

// Enable Lenis smooth scroll only on public site (not admin panel).
const Shell = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  useSmoothScroll(!isAdmin);
  useDynamicFavicon();
  return <>{children}</>;
};

function App() {
  return (
    <LangProvider>
      <ContentProvider>
        <div className="App">
          <div className="grain" aria-hidden="true" />
          <BrowserRouter>
            <Shell>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/termos" element={<Terms />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </Shell>
          </BrowserRouter>
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#3A3524",
                color: "#F5F2EC",
                border: "1px solid rgba(245,242,236,0.15)",
                borderRadius: 2,
                fontFamily: "Outfit, sans-serif",
                letterSpacing: "0.02em",
              },
            }}
          />
        </div>
      </ContentProvider>
    </LangProvider>
  );
}

export default App;
